import { Router } from '@angular/router';

import { Component, OnInit, AfterContentInit, ChangeDetectionStrategy } from '@angular/core';
import { AppGlobals } from '../../app.globals';
import { MsalService } from '@azure/msal-angular';
import { AppConfig } from '../../app.config';

@Component({
    selector: 'app-logout.component',
    template: ` `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LogoutPage implements OnInit {

  ngOnInit(): void {
    this.logoutPageFunction();
  }


  constructor(
    private authService: MsalService
  ) { }

  logoutPageFunction(): void {
    AppGlobals.ClearClientSession();

    this.authService.logoutRedirect({
      postLogoutRedirectUri: AppConfig.SiteBase
    });
}

}